// extracted by mini-css-extract-plugin
module.exports = {"modal_wrapper":"modal_modal_wrapper__2XaV7","modal":"modal_modal__2bhYs","modal__icon":"modal_modal__icon__3_6wd"};